import React from "react";
import "./Showcase.scss";
import { H3 } from "../../ui/Typography";
import { Dropdown, DropdownWithIcon } from "../../ui";
import { CalenderIcon } from "../../ui/icons";

function ShowcaseDropdown() {
  return (
    <>
      <div className="showcase-wrapper">
        <H3>Dropdown 1 ,2px Outline</H3>
        <div className="showcase-inner">
          <table className="showcase-table">
            <tbody>
              <tr>
                <td></td>
                <th>(S)h28px w166px</th>
                <th>(M)h36px w240px</th>
                <th>(L)h44px w332px</th>
                <th>(XL)h54px w412px</th>
              </tr>
              <tr>
                <th>Default</th>
                <td>
                  <Dropdown
                    name="pixel-select"
                    size="sm"
                    options={[
                      { label: "Option 1", value: "opt1" },
                      { label: "Option 2", value: "opt2" },
                      { label: "Option 3", value: "opt3", selected: true },
                    ]}
                  />
                </td>
                <td>
                  <Dropdown
                    name="pixel-select"
                    size="md"
                    options={[
                      { label: "Option 1", value: "opt1" },
                      { label: "Option 2", value: "opt2" },
                      { label: "Option 3", value: "opt3" },
                    ]}
                  />
                </td>
                <td>
                  <Dropdown
                    name="pixel-select"
                    size="lg"
                    options={[
                      { label: "Option 1", value: "opt1" },
                      { label: "Option 2", value: "opt2" },
                      { label: "Option 3", value: "opt3" },
                    ]}
                  />
                </td>
                <td>
                  <Dropdown
                    name="pixel-select"
                    size="xl"
                    options={[
                      { label: "Option 1", value: "opt1" },
                      { label: "Option 2", value: "opt2" },
                      { label: "Option 3", value: "opt3" },
                    ]}
                  />
                </td>
              </tr>
              <tr>
                <th>Disabled</th>
                <td>
                  <Dropdown
                    name="pixel-select"
                    size="sm"
                    options={[
                      { label: "Option 1", value: "opt1" },
                      { label: "Option 2", value: "opt2" },
                      { label: "Option 3", value: "opt3", selected: true },
                    ]}
                    disabled
                  />
                </td>
                <td>
                  <Dropdown
                    name="pixel-select"
                    size="md"
                    options={[
                      { label: "Option 1", value: "opt1" },
                      { label: "Option 2", value: "opt2" },
                      { label: "Option 3", value: "opt3" },
                    ]}
                    disabled
                  />
                </td>
                <td>
                  <Dropdown
                    name="pixel-select"
                    size="lg"
                    options={[
                      { label: "Option 1", value: "opt1" },
                      { label: "Option 2", value: "opt2" },
                      { label: "Option 3", value: "opt3" },
                    ]}
                    disabled
                  />
                </td>
                <td>
                  <Dropdown
                    name="pixel-select"
                    size="xl"
                    options={[
                      { label: "Option 1", value: "opt1" },
                      { label: "Option 2", value: "opt2" },
                      { label: "Option 3", value: "opt3" },
                    ]}
                    disabled
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="showcase-wrapper">
        <H3>Dropdown 2 ,2px Outline(with icons)</H3>
        <div className="showcase-inner">
          <table className="showcase-table">
            <tbody>
              <tr>
                <td></td>
                <th>(S)h28px w166px</th>
                <th>(M)h36px w240px</th>
                <th>(L)h44px w332px</th>
                <th>(XL)h54px w412px</th>
              </tr>
              <tr>
                <th>Default</th>
                <td>
                  <DropdownWithIcon
                    name="pixel-select"
                    size="sm"
                    options={[
                      { label: "Option 1", value: "opt1" },
                      { label: "Option 2", value: "opt2" },
                      { label: "Option 3", value: "opt3", selected: true },
                    ]}
                    icon={CalenderIcon}
                  />
                </td>
                <td>
                  <DropdownWithIcon
                    name="pixel-select"
                    size="md"
                    options={[
                      { label: "Option 1", value: "opt1" },
                      { label: "Option 2", value: "opt2" },
                      { label: "Option 3", value: "opt3" },
                    ]}
                    icon={CalenderIcon}
                  />
                </td>
                <td>
                  <DropdownWithIcon
                    name="pixel-select"
                    size="lg"
                    options={[
                      { label: "Option 1", value: "opt1" },
                      { label: "Option 2", value: "opt2" },
                      { label: "Option 3", value: "opt3" },
                    ]}
                    icon={CalenderIcon}
                  />
                </td>
                <td>
                  <DropdownWithIcon
                    name="pixel-select"
                    size="xl"
                    options={[
                      { label: "Option 1", value: "opt1" },
                      { label: "Option 2", value: "opt2" },
                      { label: "Option 3", value: "opt3" },
                    ]}
                    icon={CalenderIcon}
                  />
                </td>
              </tr>
              <tr>
                <th>Disabled</th>
                <td>
                  <DropdownWithIcon
                    name="pixel-select"
                    size="sm"
                    options={[
                      { label: "Option 1", value: "opt1" },
                      { label: "Option 2", value: "opt2" },
                      { label: "Option 3", value: "opt3", selected: true },
                    ]}
                    icon={CalenderIcon}
                    disabled
                  />
                </td>
                <td>
                  <DropdownWithIcon
                    name="pixel-select"
                    size="md"
                    options={[
                      { label: "Option 1", value: "opt1" },
                      { label: "Option 2", value: "opt2" },
                      { label: "Option 3", value: "opt3" },
                    ]}
                    icon={CalenderIcon}
                    disabled
                  />
                </td>
                <td>
                  <DropdownWithIcon
                    name="pixel-select"
                    size="lg"
                    options={[
                      { label: "Option 1", value: "opt1" },
                      { label: "Option 2", value: "opt2" },
                      { label: "Option 3", value: "opt3" },
                    ]}
                    icon={CalenderIcon}
                    disabled
                  />
                </td>
                <td>
                  <DropdownWithIcon
                    name="pixel-select"
                    size="xl"
                    options={[
                      { label: "Option 1", value: "opt1" },
                      { label: "Option 2", value: "opt2" },
                      { label: "Option 3", value: "opt3" },
                    ]}
                    icon={CalenderIcon}
                    disabled
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

export default ShowcaseDropdown;
